<app-loader-indicator></app-loader-indicator>
<div class="u-screen-height plan-payment-page">
  <div class="page">
    <div class="page__plan">
      <ng-container *ngIf="store.viewState.$ | async as viewState">

        <ng-container *ngIf="viewState.status === 'loading'">
          <app-signup-plan></app-signup-plan>
        </ng-container>

        <ng-container *ngIf="viewState.status === 'error'">
          <div class="full-page-message">
            <mat-card>
              <mat-card-content class="message-box">
                <h1>Error</h1>
                <div>{{viewState.error}}</div>
              </mat-card-content>
            </mat-card>
          </div>
        </ng-container>

        <ng-container *ngIf="viewState.status === 'loaded'">
          <app-signup-plan
              [selectedCountry]="getSelectedCountry(viewState.data.saga)"
              [selectedPeriod]="getSelectedPeriod(viewState.data.saga)"
          ></app-signup-plan>
        </ng-container>

      </ng-container>
    </div>
    <div class="page__register">
      <ng-container *ngIf="store.viewState.$ | async as viewState">

        <ng-container *ngIf="viewState.status === 'loaded'">
          <div class="register">
            <h2>Get started with your new subscription</h2>
            <mat-stepper #stepper orientation="vertical" [linear]="true" [selectedIndex]="stepperIndex.$ | async">
              <form [formGroup]="signupForm">
                <mat-step [stepControl]="signupForm.controls.registration" label="Set up your account" [completed]="getStepCompleted(0)" [editable]="getStepEditable(0)">
                  <app-signup-register formControlName="registration"></app-signup-register>
                  <div>
                    <button mat-button
                        class="primary"
                        type="button"
                        (click)="signupUser()"
                        [disabled]="!registrationControl?.valid || buttonState.value.account_creation.disabled">
                      {{buttonState.value.account_creation.text}}
                    </button>
                  </div>
                </mat-step>
                <mat-step [stepControl]="signupForm.controls.subscription" label="Configure your subscription" [completed]="getStepCompleted(1)" [editable]="getStepEditable(1)">
                  <app-signup-subscription
                      [plan]="viewState.data.saga?.plan!"
                      [countries]="filterCountries(viewState.data.saga!, viewState.data.countries || [])"
                      formControlName="subscription"
                  ></app-signup-subscription>
                  <div>
                    <button mat-button
                        class="primary"
                        type="button"
                        (click)="updateSubscription()"
                        [disabled]="!subscriptionControl?.valid || buttonState.value.payment_preprocessing.disabled">
                      {{buttonState.value.payment_preprocessing.text}}
                    </button>
                  </div>
                </mat-step>
                <mat-step [stepControl]="signupForm.controls.contract" label="Purchase order contract" [completed]="getStepCompleted(2)" [editable]="getStepEditable(2)">
                  <p *ngIf="!contractSigned.value" class="docusign">
                    Please confirm the subscription details on the left before proceeding, especially with
                    regards to relevant dates and pricing.<br /><br />

                    Sign the contract using the button below (this will redirect you to
                    another page for signing).
                  </p>
                  <p *ngIf="contractSigned.value" class="docusign">
                    Contract signed.<br /><br />
                    Please use the button below to verify the contract and proceed to payment
                  </p>
                  <button *ngIf="!contractSigned.value" mat-button
                      class="primary"
                      type="button"
                      (click)="signContract()"
                      [disabled]="buttonState.value.contract_signing.disabled"
                      >
                    {{buttonState.value.contract_signing.text}}
                  </button>
                  <button *ngIf="contractSigned.value" mat-button
                      class="primary"
                      type="button"
                      (click)="verifyContract(viewState.data.saga?.docusign)"
                      [disabled]="buttonState.value.contract_signing.disabled"
                      >
                    {{buttonState.value.contract_signing.text}}
                  </button>
                </mat-step>
                <mat-step [stepControl]="signupForm.controls.payment" label="Finalize payment" [completed]="getStepCompleted(3)" [editable]="getStepEditable(3)">
                  <p class="payment-note">
                    Your subscription configuration has been saved. Plase complete your payment below to activate your account
                  </p>
                  <div class="o-flex--full">
                    <div *ngIf="clientSecret.$ | async" class="client-secret">
                      <ngx-stripe-elements
                        [stripe]="stripe"
                        [elementsOptions]="elementsOptions"
                      >
                        <ngx-stripe-payment *ngIf="paymentElementOptions" [options]="paymentElementOptions" />
                      </ngx-stripe-elements>
                    </div>
                  </div>
                  <br />
                  <div>
                    <button mat-button class="primary" type="button" (click)="handlePayment()" [disabled]="disablePurchaseButton.$ | async">Complete purchase</button>
                  </div>
                </mat-step>
                <mat-step label="Signup completed" [completed]="getStepCompleted(4)" [editable]="getStepEditable(4)">
                  <p class="payment-note payment-note--indented">
                    <strong>Signup completed!</strong><br /><br />
                    Your account is now activated and you can start using the INSCYD app.<br />
                    Your login information will be sent to you via email.
                  </p>
                  <div>
                    <button mat-button class="primary" type="button" (click)="appLogin()">Start using INSCYD now</button>
                  </div>
                </mat-step>
              </form>
            </mat-stepper>

            <div class="document terms">
              <div class="document__content" [innerHtml]="viewState.data.terms">
                Terms and coditions
              </div>
              <div class="document__link">
                <a href="{{termsLink}}" target="_blank">Open in new tab<mat-icon class="icon-display">open_in_new</mat-icon></a>
              </div>
            </div>
            <div class="document privacy-policy">
              <div class="document__content" [innerHtml]="viewState.data.privacyPolicy">
                Privacy policy
              </div>
              <div class="document__link">
                <a href="{{privacyPolicyLink}}" target="_blank">Open in new tab<mat-icon class="icon-display">open_in_new</mat-icon></a>
              </div>
            </div>
          </div>
        </ng-container>

      </ng-container>
    </div>
  </div>
</div>
